module.exports = __webpack_public_path__ + "eea4e07faacf76d456466ddbaef20389.svg";